var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowcounterclockwise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25488 9.09863C8.72949 9.09863 9.10742 8.7207 9.10742 8.2373C9.10742 8 9.01953 7.80664 8.86133 7.64844L6.4707 5.27539C6.92773 5.19629 7.45508 5.15234 8.02637 5.15234C11.4102 5.15234 14.1084 7.85938 14.1084 11.2783C14.1084 14.6709 11.3926 17.3955 8 17.3955C4.61621 17.3955 1.8916 14.6709 1.8916 11.2783C1.8916 10.751 1.54883 10.373 1.03906 10.373C0.511719 10.373 0.142578 10.751 0.142578 11.2783C0.142578 15.6377 3.64941 19.1445 8 19.1445C12.3594 19.1445 15.8574 15.6377 15.8574 11.2783C15.8574 6.91895 12.377 3.43848 8.02637 3.43848C7.61328 3.43848 7.19141 3.47363 6.76953 3.53516L8.87012 1.47852C9.01953 1.31152 9.10742 1.11816 9.10742 0.880859C9.10742 0.397461 8.73828 0.00195312 8.25488 0.00195312C8 0.00195312 7.79785 0.0898438 7.63965 0.265625L4.03613 3.93066C3.85156 4.10645 3.76367 4.33496 3.76367 4.57227C3.76367 4.81836 3.84277 5.0293 4.03613 5.22266L7.64844 8.85254C7.79785 9.01953 8 9.09863 8.25488 9.09863Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcounterclockwise);
export default __webpack_public_path__ + "static/media/arrow.counterclockwise.46c4520e.svg";
export { ForwardRef as ReactComponent };